// validaciones.js

export const validarMateria = (materia, materiasExistentes) => {
  const errores = {};
  const codigoTrim = materia.codigo.trim();
  const asignaturaTrim = materia.asignatura.trim();

  if (!codigoTrim) {
    errores.codigo = "El código es obligatorio.";
  } else if (codigoTrim.length > 20) {
    errores.codigo = "El código no debe superar los 20 caracteres.";
  } else if (
    materiasExistentes.some(
      (m) =>
        m.codigo.toLowerCase() === codigoTrim.toLowerCase() &&
        m.id !== materia.id
    )
  ) {
    errores.codigo = "Este código ya está registrado.";
  }

  if (!asignaturaTrim) {
    errores.asignatura = "La asignatura es obligatoria.";
  } else if (asignaturaTrim.length > 150) {
    errores.asignatura = "La asignatura no debe superar los 150 caracteres.";
  } 

  if (!materia.horas) {
    errores.horas = "Las horas son obligatorias.";
  } else if (Number(materia.horas) <= 0) {
    errores.horas = "Debe ser un número mayor a cero.";
  }

  return errores;
};
